import { ApiError } from "@/api/client";
import { apiErrorMessage } from "@/lib/api-error-kind";

/**
 * An API refusal as the user reads it: the server's message and its
 * `error_code`, then each of its `details.diagnostics` — the project spec
 * routes' `spec_invalid` and `revision_stale_against_source` carry them
 * (Phase 2 C2.2), and a refusal without its reasons is not actionable.
 */
export function RefusalDetail({ error }: { error: unknown }): JSX.Element {
  if (!(error instanceof ApiError)) return <>{apiErrorMessage(error)}</>;
  const diagnostics = Array.isArray(error.details?.diagnostics)
    ? (error.details.diagnostics as Array<{ message?: unknown }>)
    : [];
  return (
    <>
      {error.message} <span className="font-mono text-xs">({error.errorCode})</span>
      {diagnostics.length > 0 && (
        <ul className="mt-1 list-disc pl-5 text-xs">
          {diagnostics.map((d, i) => (
            <li key={i}>{typeof d.message === "string" ? d.message : JSON.stringify(d)}</li>
          ))}
        </ul>
      )}
    </>
  );
}
